import { Component, ViewContainerRef} from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { FaqCategory } from '../../models/faq/faq-category-model';
import { FaqCategoryService } from '../../services/faq/faq-category.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-faq-category-list',
    templateUrl: './faq-category-list.component.html',
    styleUrls: ['./faq-category-list.component.scss']
})
/** faq-category-list component*/
export class FaqCategoryListComponent {
  public FaqList: FaqCategory[];
  //Filter items from grid
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
    /** faq-category-list ctor */
  constructor(private readonly FaqService: FaqCategoryService, private readonly utilitiesService: UtilitiesService,
    public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("faqcategory").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          this.getFaqs();
          this.GetRowsPerPageList();
            this.toastr.setRootViewContainerRef(vcr);
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  deleteFaqCategory(id) {
    if (confirm("Are you sure to delete this faq category?")) {
      this.FaqService.deleteFaqCategory(id).subscribe(
        response => {
          if (response) {
            this.toastr.success('FAQ Category has been Deleted.', 'Success');
            setTimeout(() => {
              this.getFaqs();
            }, 2000);
          }
          else {
            this.toastr.error('Error occurred. Please try again', 'Success');
          }
        }
      )
    }
  }
  getFaqs() {
    this.FaqService.getFaqCategories().subscribe(
      data => {
        this.FaqList = data;
        this.filteredItems = data;
      }
    )
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  onSearch(searchText: string) {
    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.FaqList, searchText);

    } else {
      this.filteredItems = this.FaqList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/faq-components/faq-category-list/faq-category-list.component.ts